<template>
 <div class="notfound-container">
     页面不存在
 </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  components: {

  }
}
</script>

<style>
  .notfound-container{
    font-size: 60px;
    line-height: 200px;
    padding: 40px;
    text-align: center;
  }
</style>
